import { animate, state, style, transition, trigger } from '@angular/animations';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Market } from '../core/markets/market';
import { MarketsService } from '../core/markets/markets.service';
import { PartnerService } from '../core/partner.service';
import { AccountGroupPermissionsService } from '../user-permissions/account-group-permissions/account-group-permissions.service';
import { indicationRotate } from '../user-permissions/expansion-panel.animations';
import { UserService } from '../users';

@Component({
  selector: 'app-market-notifications',
  templateUrl: './market-notifications.component.html',
  styleUrls: ['./market-notifications.component.scss', '../user-permissions/table.scss'],
  animations: [
    indicationRotate,
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false,
})
export class MarketNotificationsComponent {
  partnerId = this.partnerService.partnerId;

  displayedColumns = ['name', 'indicator'];
  expandedPanels: string[] = [];

  private search$$: BehaviorSubject<string> = new BehaviorSubject('');
  markets$: Observable<Market[]> = combineLatest([this.marketsService.getMarkets(), this.search$$.asObservable()]).pipe(
    map(([markets, search]) => {
      markets = [new Market({ market_id: '', partner_id: this.partnerId, name: 'Default (All Markets)' }), ...markets];
      if (!search || search === '') {
        return markets;
      }
      return markets.filter((market) => market.name.toUpperCase().indexOf(search.toUpperCase()) === -1);
    }),
  );
  partnerNotificationEnabled$ = this.partnerService.partnerNotificationEnabled$;
  readonly positions: ConnectedPosition[] = [{ ...PopoverPositions.Right }, { ...PopoverPositions.Bottom }];

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private snackbarService: SnackbarService,
    private accountGroupPermissionsService: AccountGroupPermissionsService,
    private partnerService: PartnerService,
    private marketsService: MarketsService,
  ) {}

  panelOpen(marketId: string): void {
    if (this.expandedPanels.indexOf(marketId) === -1) {
      this.expandedPanels.push(marketId);
    }
  }

  panelClose(marketId: string): void {
    const index = this.expandedPanels.indexOf(marketId);
    if (index >= 0) {
      this.expandedPanels.splice(index, 1);
    }
  }

  getExpandedState(marketId: string): string {
    return this.expandedPanels.indexOf(marketId) >= 0 ? 'expanded' : 'collapsed';
  }

  search(searchTerm: string): void {
    this.search$$.next(searchTerm);
  }

  trackById(index: number, item: any): string {
    return item.market_id;
  }
}
